import { produce } from 'immer';
import { ScopedAsyncType } from './scoped-type';
import { asyncAction } from './async-action';

import * as api from '../../lib/api';

const slice = 'auth';
const AsyncType = ScopedAsyncType('AUTH');
const LOGIN = AsyncType('LOGIN');

export const actions = {
  login: () => asyncAction(LOGIN, () => api.login()),
};

export const selectors = {
  currentUser: (state) => state[slice],
};

const typeReducers = {
  [LOGIN.start]: (state) => {
    state.isLoading = true;
  },

  [LOGIN.complete]: (state, currentUser) => {
    Object.assign(state, {
      ...currentUser,
      isLoading: false,
      isAuthenticated: true,
      userType: currentUser.role,
    });
  },
};

const initialState = {
  isLoading: true,
  isAuthenticated: false,
  name: '',
  username: '',
  userType: '',
  growers: [],
};

export const reducers = {
  [slice]: (state = initialState, { type, payload } = {}) => {
    if (!typeReducers[type]) return state;
    return produce(state, (draft) => typeReducers[type](draft, payload));
  },
};
